import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationPreferencesService } from '../../services/entities/notification-preferences.service';
import { ToastService } from '../../services/utils/toast.service';
import { NotificationPreferencesFormBase } from './notification-preferences-form.base';

/**
 * Preferenze notifiche come pannello del master-detail del profilo (stesso
 * pattern di User/Car/Lingua/Coperture). Stato e logica vivono nella base
 * condivisa: qui solo il wiring di lifecycle e l'azione di salvataggio.
 */
@Component({
  selector: 'app-notification-preferences-detail',
  templateUrl: './notification-preferences-detail.component.html',
  styleUrls: ['./notification-preferences-detail.component.scss'],
  standalone: false
})
export class NotificationPreferencesDetailComponent extends NotificationPreferencesFormBase implements OnInit {

  constructor(
    notificationPreferencesService: NotificationPreferencesService,
    toast: ToastService,
    translate: TranslateService,
  ) {
    super(notificationPreferencesService, toast, translate);
  }

  async ngOnInit() {
    await this.loadPreferences();
  }
}
